export class RequestLicenseModel {
    FirstName: string;
    LastName: string;
    CompanyName: string;
    EmailAddress: string;
    PhoneNumber: string;
    ActivationKey: string;

    constructor(params: Partial<RequestLicenseModel> = {}) {
        Object.assign(this, params);
    }
}
